import { FlexBox } from 'shared/components/Base/Base'
import { Text } from 'shared/components/Text/Text'
import { formatShortDateWindow, formatTimeWindow } from 'shared/helpers/formatters'
import { midGray, primaryBlack } from 'shared/theme/colors'

import LargeArrowIcon from '../../../assets/images/LargeArrowIcon.svg'
import { Job, StopType } from '../../../models/jobs'

interface JobDetailsStopsProps {
  job: Job
}

export function JobDetailsStops({ job }: JobDetailsStopsProps) {
  const orig = job.load.stops.find((stop) => stop.type === StopType.ORIGIN)
  const dest = job.load.stops.find((stop) => stop.type === StopType.DESTINATION)

  return (
    <FlexBox gap="12px">
      <FlexBox isColumn>
        <FlexBox justifyContent="center" gap="12px">
          <Text variant="header3" fontColor={primaryBlack}>
            {orig ? (
              <>
                {orig.location_city}, {orig.location_state}
              </>
            ) : null}
          </Text>
          <img src={LargeArrowIcon} alt="Arrow icon" height="15px" style={{ marginTop: 2 }} />
        </FlexBox>
        <Text variant="label3" fontColor={midGray}>
          {orig ? formatShortDateWindow(orig.date_start, orig.date_end) : ''}
        </Text>
        <Text variant="label3" fontColor={midGray}>
          {orig ? formatTimeWindow(orig.date_start, orig.date_end) : ''}
        </Text>
      </FlexBox>

      <FlexBox isColumn>
        <Text variant="header3" fontColor={primaryBlack}>
          {dest ? (
            <>
              {dest.location_city}, {dest.location_state}
            </>
          ) : null}
        </Text>
        <Text variant="label3" fontColor={midGray}>
          {dest ? formatShortDateWindow(dest.date_start, dest.date_end) : ''}
        </Text>
        <Text variant="label3" fontColor={midGray}>
          {dest ? formatTimeWindow(dest.date_start, dest.date_end) : ''}
        </Text>
      </FlexBox>
    </FlexBox>
  )
}
